import currency from 'currency.js';
import currenciesLocales from './currencies-locale';

export default function (value: number, locale = 'en-US'): string {
  const [start, end] = locale?.split('-');
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: (currenciesLocales as any)[`${start}-${end.toUpperCase()}`],
  }).format(currency(value).value);
}
